import { ActionCreatorWithPayload } from '@reduxjs/toolkit';
import React from 'react';
import { connect } from 'react-redux';

import { RequireRole } from 'app/components/require-role';
import { Role } from 'app/constants/role';
import { MenuItemData } from 'app/model/menu-item';

import { HeaderMenu } from './header-menu';
import { setMccLookupVisible } from '../tools/slice';

interface HelpMenuProps {
    setMccLookupVisible: (visible: boolean) => void;
}

class HelpMenu extends React.Component<HelpMenuProps> {
    public render(): React.ReactNode {
        const options: MenuItemData[] = [
            {
                name: 'MCC Lookup',
                icon: 'manage_search',
                onClick: () => {
                    this.props.setMccLookupVisible(true);
                },
                role: Role.USER,
            },
        ];

        // once we have some items that don't require login we can remove this RequireRole
        return (
            <RequireRole roles={Role.USER}>
                <HeaderMenu options={options} icon='help' />
            </RequireRole>
        );
    }
}

const actions = { setMccLookupVisible: setMccLookupVisible as ActionCreatorWithPayload<boolean> };

const enhanced = connect(undefined, actions)(HelpMenu);

export { enhanced as HelpMenu };
